/*
 * @Author: QiuYu 
 * @Date: 2020-05-12 13:45:06 
 * @Last Modified by: QiuYu
 * @Last Modified time: 2020-08-20 17:26:18
 */

// 表格
//   特性：
//     点击排序
//     表头固定
//     左侧代码名称固定，右侧数据可以拖动
//     点击加载更多
//     自刷



import merge from "lodash/merge";

declare var Hammer:any;

interface listConf {
  dataprocessData(data: any): any;
  dataprocess: any;
  ele: String;
  refresh: Number;
  tabconfig: any;
  tabindex: Number;
}

/**
 * @class QuoteList
 * @Title QuoteList`
 * @description 组件封装
 * @params: ele               生成的表格插入的 domid
 * @params: fix                 表格表头是否固顶
 * @params: isrefresh             表格是否支持自刷
 * @params: refresh_time        表格自刷时间间隔(单位 ：毫秒)
 */
class QuoteList {
  list_config:any = {
    tabindex : 0
  }

  list_timer: any = null
  debounce_timer:any = null
  constructor(options: any) {
    this.list_config = merge(this.list_config, options);
  }

  // 初始化表格 
  init() {
    let self = this;
    self.showList();
  }

  destroy(){
    let self = this;
    clearInterval(self.list_timer)
    $(`#${self.list_config.ele}`).html('')
  }

  showList() {
    let self = this;
    self.makeTab()
    self.makeList()
  }

  // Ajax 请求
  async getDataAjax(url: any) {
    // Ajax数据请求
    let self = this
    // let rnd = 'callbackdata' + Math.floor(Math.random() * 10000000 + 1);
    let backdata = new Promise(function (res, rej) {
      try {
        $.ajax({
          url: url ,
          type: 'GET',
          timeout: 15000,
          dataType: 'jsonp',
          success: function (data) {
            // 返回成功数据
            if (data && data.rc == "0") {
              res(data)
            } else {
              rej([]);
            }
          },
          error: function (err) {
            rej([])
          }
        });
      } catch (error) {
        // 错误处理
      }
    })

    return backdata.then(function (v: any) {
      return v
    }).catch(function (ErrMsg: any) {
      return []
    });

  }

  // 生成tab
  makeTab() {
    // 生成 tap 栏
    let self = this;
    let _list = $(`#${self.list_config.ele}`);
    _list.html('')
    _list.append($(`<div class='tabs'></div>`))
    let list_tab = _list.find('.tabs')
    self.list_config.tabconfig.tabitem.forEach((item: any, index: any) => {
      if (index == 0) {
        list_tab.append($(`<span hidefocus="true" class="active" value="${index}">${item.title}</span>`))
      } else {
        list_tab.append($(`<span href="#" hidefocus="true" value="${index}">${item.title}</span>`))
      }
    })
  }

  // 生成 list
  async makeList() {
    let self = this;
    let _list = $(`#${self.list_config.ele}`);
    // 增加表格容器
    _list.append($(`<section class='carousel'><ul></ul></section>`))
    let list_ul = _list.find('ul')

    // 获取每个单页表格数据
    let tabitem = self.list_config.tabconfig.tabitem
    let hasTitle = false
    for (let i = 0; i < tabitem.length; i++) {
      // 创建每个tab对应的列表
      if (i == 0) {
        let data = await self.getDataAjax(tabitem[i].api)
        let htmlresult = ''

        let res
        try {
          if(tabitem[i].dataprocess){
            res = tabitem[i].dataprocessData(data)
          }else{
            res = data?.data?.diff
          }
          if(res instanceof Array && res.length>0){
            // 列表有数据的时候
            let dom_dd_title = '<dd class="quote-list-title">'
            tabitem[i].body.forEach((item: any) => {
              if(item.title){
                hasTitle = true
                dom_dd_title += `<div>${item.title}</div>`
              }
            })
            dom_dd_title += '</dd>'
            res.forEach((ele: any) => {
              let dom_dd = ''
              tabitem[i].body.forEach((item: any) => {
                // 每个list的全部数据
                dom_dd += item.html(ele)
              })
              if(ele.f12 == undefined || ele.f13 == undefined){
                dom_dd = `<dd>${dom_dd}</dd>`
              }else{
                dom_dd = `<dd><a href='/quote/stock/${ele.f13 == '128' ? '116' : ele.f13}.${ele.f12}.html' target="_blank">${dom_dd}</a></dd>`
              }
              htmlresult += dom_dd
            })
            if(hasTitle){
              htmlresult = dom_dd_title + htmlresult
            }
          }else{
            // 列表无数据的时候
            let result = tabitem[i].noData()
            htmlresult += result
          }
        } catch (error) {
          // console.error(error)
          // 列表无数据的时候
          let result = tabitem[i].noData()
          htmlresult += result
        }
        
        htmlresult = `<li>${htmlresult}</li>`
        list_ul.append(`${htmlresult}`)
      } else {
        list_ul.append(`<li></li>`)
      }
    }
    // 给表格绑定数据
    self.bindFun()
  }

  refreshData(options: any) {
    let self = this
    let times = Number(self.list_config.refresh)
    clearInterval(self.list_timer)
    self.list_timer = null
    if (times > 0) {
      // 开启刷新
      self.list_timer = setInterval(function () {
        // 刷新前取消滑动动作 防止页面卡死
        self.setTransition(1, 1, 1, options);
        self.setTransform(0, options);
        self.upData(Number(self.list_config.tabindex))
      }, times * 1000)
    }
  }

  // 数据更新
  async upData(tabindex: number) {
    let self = this
    let tabitem = self.list_config.tabconfig.tabitem
    
    let data = await self.getDataAjax(tabitem[tabindex].api)
    // 对数据进行更新
    
    let res
    let htmlresult = ''
    let dom_dd = ''
    let hasTitle = false

    try {
      if(tabitem[tabindex].dataprocess){
        res = tabitem[tabindex].dataprocessData(data)
      }else{
        res = data.data.diff
      }
      if(res.length > 0){
        let dom_dd_title = '<dd class="quote-list-title">'
        tabitem[tabindex].body.forEach((item: any) => {
          if(item.title){
            hasTitle = true
            dom_dd_title += `<div>${item.title}</div>`
          }
        })
        dom_dd_title += '</dd>'
        res.forEach((ele: any) => {
          dom_dd = ''
          tabitem[tabindex].body.forEach((item: any) => {
            // 每个list的全部数据
            dom_dd += item.html(ele)
          })
          if(ele.f12 == undefined || ele.f13 == undefined){
            dom_dd = `<dd>${dom_dd}</dd>`
          }else{
            dom_dd = `<dd><a href='/quote/stock/${ele.f13 == '128' ? '116' : ele.f13}.${ele.f12}.html' target="_blank">${dom_dd}</a></dd>`
          }
          htmlresult += dom_dd
        })
        if(hasTitle){
          htmlresult = dom_dd_title + htmlresult
        }
      }else{
        // 没有获得数据
        htmlresult += tabitem[tabindex].noData()
      }
    } catch (error) {
      // 列表无数据的时候
      let result = tabitem[tabindex].noData()
      htmlresult += result
    }
    
    $(`#${self.list_config.ele}`).find('li').get(tabindex)!.innerHTML = htmlresult
  }

  // 列表注册事件
  bindFun() {
    let self = this
    let ele: any = document.querySelector(`#${self.list_config.ele}`)
    let carousel: any = ele.querySelector('.carousel');
    let carouselUl = carousel.querySelector('ul');
    let carouselLis = carouselUl.querySelectorAll('li');
    let tabDom = ele.querySelectorAll('.tabs')[0];
    // 屏幕的宽度
    let screenWidth = document.documentElement.offsetWidth;

    // 设置 ul 的高度
    carouselUl.style.height = carouselLis[0].offsetHeight + 'px';
    // 初始三个固定的位置
    let left = carouselLis.length - 1;
    let center = 0;
    let right = 1;

    let bindObj = {
      carousel: carousel,
      carouselUl: carouselUl,
      carouselLis: carouselLis,
      tabDom: tabDom,
      screenWidth: screenWidth,
      left: left,
      center: center,
      right: right,
      startTime: 0,
      startX: 0,
    }
    // 归位（多次使用，封装成函数）
    self.setTransform(0, bindObj);

    // 分别绑定touch事件
    var hemmertime = new Hammer(carouselUl)
    hemmertime.get('pan').set({ direction: Hammer.DIRECTION_HORIZONTAL });
    hemmertime.on('panstart',function(e:any){
      self.setTransition(0, 0, 0, bindObj);
    })
    hemmertime.on('panmove',function(e:any){
      e.preventDefault()
      self.setTransform(e.deltaX, bindObj)
    },false)
    hemmertime.on('panend',function(e:any){
        // 在手指松开的时候，要判断当前是否滑动成功
        let dx = e.deltaX;
        // 滑动成功的依据是滑动的距离（绝对值）超过屏幕的三分之一 或者滑动的时间小于300毫秒同时滑动的距离大于30
        if (Math.abs(dx) > screenWidth / 3 ) {
          // 滑动成功了
          // 判断用户是往哪个方向滑
          if (dx > 0) {
            // 往右滑 看到上一张
            if (bindObj.center !== 0) {
              self.showPrev(bindObj);
            } else {
              self.setTransition(1, 1, 1, bindObj);
              self.setTransform(0, bindObj);
            }
          } else {
            // 往左滑 看到下一张
            if (bindObj.center !== carouselLis.length - 1) {
              self.showNext(bindObj);
            } else {
              self.setTransition(1, 1, 1, bindObj);
              self.setTransform(0, bindObj);
            }
          }
        } else {
          // 添加上过渡
          self.setTransition(1, 1, 1, bindObj);
          // 滑动失败了
          self.setTransform(0, bindObj);
        }
    })
         
    tabDom.addEventListener('click', function (e: any) {

      if (!(e.target.className == 'active')) {
        // 选择与当前不同的tab的时候调用
        self.checkTabs(tabDom, e.target, true, bindObj)
      }
    })
    self.refreshData(bindObj)
  }

  setTransform(dx: any, options: any) {
    let self = this
    dx = dx || 0;
    if (options.center == 0) {
      options.carouselLis[options.left].style.transform = 'translateX(' + (options.screenWidth * (options.carouselLis.length - 1) + dx) + 'px)';
      options.carouselLis[options.center].style.transform = 'translateX(' + dx + 'px)';
      options.carouselLis[options.right].style.transform = 'translateX(' + (options.screenWidth + dx) + 'px)';
    } else if (options.center == options.carouselLis.length - 1) {
      options.carouselLis[options.left].style.transform = 'translateX(' + (-options.screenWidth + dx) + 'px)';
      options.carouselLis[options.center].style.transform = 'translateX(' + dx + 'px)';
      options.carouselLis[options.right].style.transform = 'translateX(' + (2 * options.screenWidth + dx) + + 'px)';
    } else {
      options.carouselLis[options.left].style.transform = 'translateX(' + (-options.screenWidth + dx) + 'px)';
      options.carouselLis[options.center].style.transform = 'translateX(' + dx + 'px)';
      options.carouselLis[options.right].style.transform = 'translateX(' + (options.screenWidth + dx) + 'px)';
    }
  }

  setTransition(a: number, b: number, c: number, options: any) {
    // 设置过渡
    if (a) {
      options.carouselLis[options.left].style.transition = 'transform 0.5s cubic-bezier(.17,.67,.84,.90)';
    } else {
      options.carouselLis[options.left].style.transition = 'none';
    }
    if (b) {
      options.carouselLis[options.center].style.transition = 'transform 0.5s cubic-bezier(.17,.67,.84,.90)';
    } else {
      options.carouselLis[options.center].style.transition = 'none';
    }
    if (c) {
      options.carouselLis[options.right].style.transition = 'transform 0.5s cubic-bezier(.17,.67,.84,.90)';
    } else {
      options.carouselLis[options.right].style.transition = 'none';
    }
  }

  // 轮播图片切换下一张
  showNext(options: any) {
    let self = this
    // 轮转下标
    options.left = options.center;
    options.center = options.right;
    options.right++;
    self.list_config.tabindex = options.center
    //　极值判断
    if (options.right > options.carouselLis.length - 1) {
      options.right = 0;
    }
    self.checkTabs(options.tabDom, options.tabDom.children[options.center], false, options)
    //添加过渡（多次使用，封装成函数）
    self.setTransition(1, 1, 0, options);
    // 归位
    self.setTransform(0, options);
  }

  // 轮播图片切换上一张
  showPrev(options: any) {
    let self = this
    // 轮转下标
    options.right = options.center;
    options.center = options.left;
    options.left--;
    self.list_config.tabindex = options.center
    //　极值判断
    if (options.left < 0) {
      options.left = options.carouselLis.length - 1;
    }
    self.checkTabs(options.tabDom, options.tabDom.children[options.center], false, options)
    //添加过渡
    self.setTransition(0, 1, 1, options);
    // 归位
    self.setTransform(0, options);
  }

  // tab切换
  async checkTabs(tab: any, dom: any, isCheck: any, options: any) {
    let self = this
    for (let i = 0; i < tab.children.length; i++) {
      tab.children[i].classList.remove('active')
    }
    dom.classList.add('active')
    // 跳转到对应页面
    if (isCheck) {
      self.showAppiont(dom.getAttribute('value'), options)
    }
    // 切换tab时  立即获取新的数据 并刷新
    self.setTransition(0, 0, 0, options);
    self.setTransform(0, options);
    await self.upData(Number(self.list_config.tabindex))
    // 根据列表动态设置高度
    options.carouselUl.style.height = options.carouselLis[Number(self.list_config.tabindex)].offsetHeight + 'px';
    self.refreshData(options)
  }
  // 轮播图片跳转到指定页面
  showAppiont(num: number, options: any) {
    let self = this
    //添加过渡
    self.setTransition(0, 0, 0, options);
    let dx = options.center - num
    options.center = Number(num)
    self.list_config.tabindex = options.center
    if (options.center == 0) {
      options.left = options.carouselLis.length - 1;
      options.right = 1
    } else if (options.center == options.carouselLis.length - 1) {
      options.right = 0
      options.left = options.center - 1
    } else {
      options.right = options.center + 1
      options.left = options.center - 1
    }
    // 归位
    for (let i = 0; i < options.carouselLis.length; i++) {
      options.carouselLis[i].style.transform = 'translateX(300%)';
    }
    // 归位
    self.setTransform(0, options);
  }


}

export default QuoteList